// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2VJ9G","buttons":"PendingPaymentAlert_buttons__2bgcb"};